import script from "./controlPanel.vue?vue&type=script&lang=js"
export * from "./controlPanel.vue?vue&type=script&lang=js"

import "./controlPanel.vue?vue&type=style&index=0&id=15308994&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15308994"]])

export default __exports__